import React from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import classNames from "classnames";

import "./Slide.scss";

export class Slide extends React.Component {
  static defaultProps = {
    timeout: 1000,
    isVisible: false,
    direction: "vertical",
    unmountOnExit: false,
  };

  static propTypes = {
    children: PropTypes.any,
    direction: PropTypes.oneOf(["vertical", "horizontal"]),
    timeout: PropTypes.number,
    isVisible: PropTypes.bool,
    unmountOnExit: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      exited: !props.isVisible,
      entered: props.isVisible,
    };
  }

  setVisibility = (newIsVisible) => {
    this.setState({
      exited: !newIsVisible,
      entered: newIsVisible,
    });
  };

  clearVisibility = () => {
    this.setState({
      exited: false,
      entered: false,
    });
  };

  onEntered = () => {
    this.setVisibility(true);
  };

  onExited = () => {
    this.setVisibility(false);
  };

  render() {
    const { children, direction, isVisible, timeout, unmountOnExit } =
      this.props;
    const { entered, exited } = this.state;

    const slideClass = classNames(
      "slide",
      direction,
      {
        exited,
        entered,
      },
      {
        enter: isVisible,
        exit: !isVisible,
      }
    );

    return (
      <CSSTransition
        in={isVisible}
        className={slideClass}
        timeout={timeout}
        unmountOnExit={unmountOnExit}
        onEntered={this.onEntered}
        onExited={this.onExited}
        onEnter={this.clearVisibility}
        onExit={this.clearVisibility}
      >
        <div>{children}</div>
      </CSSTransition>
    );
  }
}
